import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { MGMT_COMPONENT_LIST, MGMT_COMPONENT_ADD, MGMT_COMPONENT_DETAIL, MGMT_COMPONENT_UPDATE } from '../../actions';
import {
  MgmtComponentListSuccess, MgmtComponentListError,
  MgmtComponentAddSuccess, MgmtComponentAddError,
  MgmtComponentDetailSuccess, MgmtComponentDetailError,
  MgmtComponentUpdateSuccess, MgmtComponentUpdateError
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/component/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/component/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/component/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/component/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(MgmtComponentListSuccess(response.data)); }
  catch (error) { yield put(MgmtComponentListError(error)); }
}
function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(MgmtComponentAddSuccess(response.data));
  } catch (error) { yield put(MgmtComponentAddError(error)); }
}
function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(MgmtComponentDetailSuccess(response.data.data)); }
  catch (error) { yield put(MgmtComponentDetailError(error)); }
}
function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(MgmtComponentUpdateSuccess(response.data));
  } catch (error) { yield put(MgmtComponentUpdateError(error)); }
}

export function* watchList() { yield takeEvery(MGMT_COMPONENT_LIST, onList); }
export function* watchAdd() { yield takeEvery(MGMT_COMPONENT_ADD, onAdd); }
export function* watchDetail() { yield takeEvery(MGMT_COMPONENT_DETAIL, onDetail); }
export function* watchUpdate() { yield takeEvery(MGMT_COMPONENT_UPDATE, onUpdate); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchDetail), fork(watchUpdate)]);
}
